// View dispatch and sign-out.
import { renderExercise } from "./features/exercise-player.js";
import { state } from "./state.js";
import { supabase } from "./supabase-client.js";
import { adminView } from "./views/admin.js";
import { authPage, verificationPage } from "./views/auth.js";
import { parentView } from "./views/parent.js";
import { profileSelection } from "./views/profile.js";
import { accountView, exercisesView, homeView, progressView } from "./views/student.js";
import { teacherExercisesView } from "./views/teacher-exercises.js";
import {
  teacherAIView,
  teacherAccountView,
  teacherClassesView,
  teacherProgressView,
  teacherView
} from "./views/teacher.js";

export async function logout() {
  document.querySelectorAll("[data-admin-logout]").forEach(button => {
    button.disabled = true;
  });

  try {
    await supabase.auth.signOut();
  } catch (error) {
    console.warn("Remote sign-out failed; the local session will still be cleared.", error);
  } finally {
    state.session = null;
    state.account = null;
    state.roles = [];
    state.profiles = [];
    state.profile = null;
    state.exercises = [];
    state.teacherMode = false;
    state.parentMode = false;
    state.adminMode = false;
    state.parentOverview = [];
    state.parentActivity = [];
    state.parentResults = [];
    state.parentSelectedChild = null;
    state.classes = [];
    state.betaInviteToken = "";
    state.betaInviteDetails = null;
    state.verificationEmail = "";
    localStorage.removeItem("brainmath-profile");
    localStorage.removeItem("brainmath-beta-invite");
    sessionStorage.removeItem("brainmath-parent-child-mode");
    history.replaceState({}, "", "/");
    render();
    requestAnimationFrame(() => window.scrollTo({ top: 0, left: 0, behavior: "auto" }));
  }
}

export function render() {
  document.documentElement.lang = state.language;
  if (!state.session && location.pathname === "/verify-email") return verificationPage();
  if (!state.session && state.verificationEmail) return verificationPage();
  if (!state.session) return authPage(state.betaInviteToken ? "register" : "login");
  const learnerOnly = state.roles.includes("learner") && !state.roles.includes("parent") && !state.roles.includes("teacher");
  if (learnerOnly && !state.profile && state.profiles.length) {
    state.profile = state.profiles[0];
    localStorage.setItem("brainmath-profile", state.profile.id);
  }
  if (state.adminMode) return adminView();
  if (state.parentMode && state.roles.includes("parent")) return parentView();
  if (state.teacherMode) {
    if (state.view === "classes") return teacherClassesView();
    if (state.view === "exercises") return teacherExercisesView();
    if (state.view === "ai") return teacherAIView();
    if (state.view === "progress") return teacherProgressView();
    if (state.view === "account") return teacherAccountView();
    return teacherView();
  }
  if (!state.profile) return state.roles.includes("parent") ? parentView() : profileSelection();
  if (state.exerciseSession) return renderExercise();
  switch (state.view) {
    case "exercises": exercisesView(); break;
    case "progress": progressView(); break;
    case "account": accountView(); break;
    default: homeView();
  }
}
